import { Box, Button, Icon, List, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  usageLimit: number
  usage: number
}

export const ModernPlan = ({ usageLimit, usage }: Props) => {
  const { navigation } = useNavigation()

  const unlimited = usageLimit === -1

  const planInformation = unlimited
    ? i18n.t('billing.your_recruitment_plan.modern_plans.unlimited')
    : i18n.t('billing.your_recruitment_plan.modern_plans.limited', {
        usage: usage,
        limit: usageLimit,
        plan_limit: usageLimit,
      })

  return (
    <Box flexDirection="row">
      <Box flexDirection="row" flexGrow>
        <Box gap="s12">
          <Icon.Large icon="user-search" color="radicalRed1000" />
          <Text.Header2 color="grey1000" weight="semibold">
            {i18n.t('billing.your_recruitment_plan.modern_plans.title')}
          </Text.Header2>
          <Text.Normal color="grey800">
            {i18n.t('billing.your_recruitment_plan.modern_plans.description')}
          </Text.Normal>
        </Box>
      </Box>

      <Box
        flexDirection="row"
        justifyContent="flexEnd"
        alignItems="center"
        flexGrow
        maxHeight="s64"
      >
        <List>
          <List.Item>
            <Box gap="s12" minWidth="s400">
              <Box flexDirection="row" justifyContent="spaceBetween" gap="s16">
                <Box>
                  <Text size="300" weight="semibold">
                    {i18n.t('billing.your_recruitment_plan.modern_plans.active_jobs')}
                  </Text>
                  <Text size="200" weight="medium">
                    {planInformation}
                  </Text>
                </Box>
                <Button.Router
                  to={navigation.ats.jobs.fullPath()}
                  type="secondary"
                  iconName="arrow-right"
                />
              </Box>
            </Box>
          </List.Item>
        </List>
      </Box>
    </Box>
  )
}
